import { combineReducers } from "redux";
export const types = {
  SET_INFO_VISIBLE: "TRINITY_RESULT/SET_INFO_VISIBLE",
  SET_RESULT: "TRINITY_RESULT/SET_RESULT",
};
const initialState = {
  result: [],
  uiState: {
    infoVisible: false,
    info: "<p>裸分为2026年该专业裸考统招80个志愿对应的最低录取分（为/表示2026年该专业未对应招生）。</p><p>报考举例：比如预估高考600分左右，初审要求差不多（毕竟每年有波动）且裸分在585分（甚至更低一点去保）以上的院校专业，即是三位一体的重点目标。</p><p>招生章程为必读文件，若考生有专项条件，以目标院校的三位一体招生章程为准。</p><p>更多三位一体信息见 <a style='text-decoration: none;color: blue;' href='/articlelist?categoryId=1&classId=1'>三位一体专栏。<a></p>",
  },
};
export const actions = {
  //设置统计信息的显示
  setStatInfoVisible: (infoVisible) => {
    return {
      type: types.SET_INFO_VISIBLE,
      infoVisible,
    };
  },
  //设置结果数据
  setResult: (result) => {
    return {
      type: types.SET_RESULT,
      result,
    };
  },
};
//三一精灵的选考科目数据
const trinityResultData = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_RESULT:
      return { ...state, result: action.result };
    default:
      return { ...state };
  }
};
// 控制三一精灵弹出框的显示和关闭
const trinityResultUiData = (state = initialState.uiState, action) => {
  switch (action.type) {
    case types.SET_INFO_VISIBLE:
      return {
        ...state,
        infoVisible: action.infoVisible,
      };
    default:
      return { ...state };
  }
};
const reducer = combineReducers({
  trinityResultUiData,
  trinityResultData,
});
export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/trinityResult.js